/**
 * phi-size-guide-drawer - Custom element (like cart-drawer)
 * Size guide slide-in drawer from right
 */
class PhiSizeGuideDrawer extends HTMLElement {
  constructor() {
    super();
    this.activeElement = null;

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('.phi-size-guide-drawer__overlay')?.addEventListener('click', this.close.bind(this));
  }

  connectedCallback() {
    // Move to body level so position:fixed covers the full viewport
    // (same pattern as cart-drawer — avoids stacking context issues from parent transforms)
    if (this.parentElement !== document.body) {
      document.body.appendChild(this);
      return; // connectedCallback fires again after the move
    }
    if (this.bound) return;
    this.bound = true;
    this.bindTrigger();
    this.bindCloseButton();
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const panel = this.querySelector('.phi-size-guide-drawer__panel');
        const closeBtn = this.querySelector('.phi-size-guide-drawer__close');
        if (typeof trapFocus === 'function') {
          trapFocus(panel, closeBtn);
        }
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(this.activeElement);
    }
    document.body.classList.remove('overflow-hidden');
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  bindTrigger() {
    // Event delegation: trigger can be anywhere (e.g. in main-product), drawer in theme.liquid
    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-phi-size-guide-trigger]');
      if (!trigger) return;
      const targetId = trigger.getAttribute('data-target');
      if (!targetId || !targetId.startsWith('#')) return;
      const drawer = document.querySelector(targetId);
      if (drawer === this) {
        e.preventDefault();
        this.open(trigger);
      }
    });
  }

  bindCloseButton() {
    const closeBtn = this.querySelector('.phi-size-guide-drawer__close');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => this.close());
    }
  }
}

customElements.define('phi-size-guide-drawer', PhiSizeGuideDrawer);
